export default {
  props: {
    leftFixed: Boolean,
    rightFixed: Boolean
  },
  computed: {
    shouldRenderSelection () {
      return !this.rightFixed && this.selection
    }
  }
}



// WEBPACK FOOTER //
// ./~/vue2-datatable-component/src/_mixins/shouldRenderSelection.js